<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="btn btn-rose">Edit Datacenter</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="editWarehouseForm" (ngSubmit)="saveWareHouse()" novalidate>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6">
                        <mat-form-field color="accent">
                            <mat-label>Datacenter Name</mat-label>
                            <input matInput type="text" placeholder="Datacenter Name" name="warehouseName" formControlName="warehouseName" required pattern=".*\S.*">
                            <mat-error
                            *ngIf="editWarehouseForm.get('warehouseName').hasError('required')"
                          >
                            Datacenter Name is required.
                          </mat-error>
                          <mat-error
                            *ngIf="editWarehouseForm.get('warehouseName').hasError('maxlength')"
                          >
                          Datacenter Name cannot be more than 50 characters.
                          </mat-error>
                        </mat-form-field>
                    </div> 
                    <div class="col-12 col-sm-12 col-md-6">
                        <mat-form-field color="accent">
                            <mat-label>Description</mat-label>
                            <input matInput type="text" placeholder="Description" name="description" formControlName="description" 
                             pattern=".*\S.*" required>
                             <mat-error
                             *ngIf="editWarehouseForm.get('description').hasError('required')"
                           >
                             Description is required.
                           </mat-error>
                           <mat-error
                             *ngIf="editWarehouseForm.get('description').hasError('maxlength')"
                           >
                             Description cannot be more than 100 characters.
                           </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6" *ngIf="states!=null">
                        <mat-form-field color="accent">
                            <mat-label>Select State</mat-label>
                            <mat-select (selectionChange)="onSelectionchange($event)"   required formControlName="stateId">
                                <mat-option [value]="null">Select an option</mat-option>
                                <mat-option *ngFor="let state of states; let i = index;" [value]="state.stateId">
                                    {{state.stateName}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                            *ngIf="editWarehouseForm.get('stateId').hasError('required')"
                          >
                            State is required.
                          </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6" *ngIf="cities!= null">
                        <mat-form-field color="accent">
                            <mat-label>Select City</mat-label>
                            <mat-select formControlName="cityId" required>
                                <mat-option [value]="null">Select an option</mat-option>
                                <mat-option *ngFor="let city of cities" [value]="city.cityId">
                                    {{city.cityName}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                            *ngIf="editWarehouseForm.get('cityId').hasError('required')"
                          >
                            City is required.
                          </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6">
                        <mat-form-field>
                            <mat-label>Address</mat-label>
                            <input matInput type="text" placeholder="Address" name="address" formControlName="address" required>
                            <mat-error
                            *ngIf="editWarehouseForm.get('address').hasError('required')"
                          >
                            Address is required.
                          </mat-error>
                          <mat-error
                            *ngIf="editWarehouseForm.get('address').hasError('maxlength')"
                          >
                          Address be more than 250 characters.
                          </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6" *ngIf="userOptionsDto.length!=null">
                        <mat-form-field color="accent">
                            <mat-label>Select Manager</mat-label>
                            <mat-select placeholder="Manager" formControlName="warehouseManagerId">
                                <mat-option  [value]="null">Select an option or ignore</mat-option>
                                <mat-option  matTooltip={{user.email}} *ngFor="let user of userOptionsDto; let i = index;" 
                                [matTooltipClass]="'option-tooltip'"
                                    [value]="user.userId">
                                    {{user.employeeId}} | {{user.firstName}} {{user.lastName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
        <mat-card-footer>
             
            <div class="row action-btn justify-content-center">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose" (click)="saveWareHouse()"
                    [disabled]="!editWarehouseForm.valid || !editHouse.stateId || !editHouse.cityId || this.cities.length == 0|| editHouse.cityId == 0">Update</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>